/* Acumen homepage configurator — Dining table / Wall shelf tabs, and the wall-shelf picker.
   Tabs: default to the shelf tab in Christmas phases c and d (window.AcumenXmas), or when the URL hash is #shelf.
   Shelf: bracket → finish → length; price is the cheapest variant at that length on the chosen shelf page;
   "Design this shelf" deep-links with rm_len / rm_fin, which assets/acumen-route-map.js applies on arrival. */
(function () {
  var STRIP = { clear: 'clear', lime: 'lime', grey: 'grey', forest: 'forest', antique: 'antique', rugger: 'rugger', jacobean: 'jacobean' };
  var BCPO = { clear: 'Clear Wax', lime: 'Lime Wax', grey: 'Grey Wash', forest: 'Forest Brown', antique: 'Antique Oak', rugger: 'Rugger Brown', jacobean: 'Jacobean' };
  function slug(name) {
    var n = (name || '').toLowerCase();
    for (var k in STRIP) if (n.indexOf(k) > -1) return k;
    return null;
  }

  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-cf-tab]');
    if (!tabs.length) return;
    function show(which) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-cf-tab') === which;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      root.querySelectorAll('[data-cf-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-cf-panel') !== which; });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-cf-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var next = t.getAttribute('data-cf-tab') === 'table' ? 'shelf' : 'table';
        show(next); root.querySelector('[data-cf-tab="' + next + '"]').focus();
      });
    });
    var X = window.AcumenXmas, ph = X ? X.phase : 'a';
    show(location.hash === '#shelf' || ph === 'c' || ph === 'd' ? 'shelf' : 'table');
  }

  function initShelf(box) {
    var data;
    try { data = JSON.parse(box.querySelector('[data-sc-data]').textContent); } catch (e) { return; }
    var cdn = box.getAttribute('data-cdn');
    var state = { br: 'lipped', fin: 'rugger', len: 120 };
    var brBox = box.querySelector('[data-sc-brs]');
    var photo = box.querySelector('[data-sc-photo]'), strip = box.querySelector('[data-sc-strip]');
    var lenSel = box.querySelector('[data-sc-len]'), price = box.querySelector('[data-sc-price]');
    var note = box.querySelector('[data-sc-pricenote]'), cta = box.querySelector('[data-sc-cta]');

    data.forEach(function (b) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'sc__br'; btn.setAttribute('data-br', b.k); btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', b.name + ' bracket');
      btn.innerHTML = (b.best ? '<span class="sc__best">Best seller</span>' : '') +
        '<img alt="" loading="lazy" src="' + b.img + '" style="object-position:' + b.pos + '">' +
        '<span class="sc__brn">' + b.name + '</span><small>from £' + Math.round(b.from) + '</small>';
      btn.addEventListener('click', function () { state.br = b.k; render(); });
      brBox.appendChild(btn);
    });
    box.querySelectorAll('[data-sc-fin]').forEach(function (btn) {
      btn.addEventListener('click', function () { var s = slug(btn.getAttribute('data-sc-fin')); if (s) { state.fin = s; render(); } });
    });
    lenSel.addEventListener('change', function () { state.len = parseInt(lenSel.value, 10); render(); });

    function render() {
      var b = data.filter(function (x) { return x.k === state.br; })[0] || data[0];
      var bare = b.k === 'floating' || b.k === 'none';
      var all = Object.keys(b.prices).map(Number);
      // standard lengths up to 300cm; ignore the stray 235cm entry where a 240cm variant exists
      var lens = all.filter(function (n) { return n > 0 && n <= 300 && !(n === 235 && all.indexOf(240) > -1); }).sort(function (a, c) { return a - c; });
      if (lens.length && lens.indexOf(state.len) < 0) {
        state.len = lens.reduce(function (a, c) { return Math.abs(c - state.len) < Math.abs(a - state.len) ? c : a; });
      }
      lenSel.innerHTML = lens.map(function (l) { return '<option value="' + l + '"' + (l === state.len ? ' selected' : '') + '>' + l + 'cm</option>'; }).join('');
      var p = b.prices[String(state.len)];
      price.textContent = p ? '£' + (p % 1 ? p.toFixed(2) : p) : '£' + Math.round(b.from);
      note.textContent = '38mm · shallowest depth · ' + (b.k === 'none' ? 'shelf only, no brackets' : b.k === 'floating' ? 'hidden floating bracket included' : '2 brackets included');
      photo.src = b.img; photo.style.objectPosition = b.pos; photo.alt = b.name + ' bracket shelf';
      strip.src = cdn + 'shelf-finish-strip-v2-' + state.fin + '-no-brackets.jpg?width=900'; // colour only, so no bracket in the way
      strip.alt = 'Rustic shelf in ' + BCPO[state.fin];
      box.querySelector('[data-sc-brname]').textContent = b.name;
      box.querySelector('[data-sc-finname]').textContent = BCPO[state.fin].toLowerCase();
      cta.textContent = b.k === 'none' ? 'Design this shelf' : 'Design this ' + b.name.toLowerCase() + ' shelf';
      cta.href = '/products/' + b.h + '?rm_len=' + state.len + 'cm&rm_fin=' + encodeURIComponent(BCPO[state.fin]);
      brBox.querySelectorAll('[data-br]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-br') === b.k ? 'true' : 'false'); });
      box.querySelectorAll('[data-sc-fin]').forEach(function (x) { x.setAttribute('aria-pressed', slug(x.getAttribute('data-sc-fin')) === state.fin ? 'true' : 'false'); });
    }
    render();
  }

  function boot() {
    document.querySelectorAll('[data-acumen-configure]').forEach(initTabs);
    document.querySelectorAll('[data-shelf-config]').forEach(initShelf);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
